import ESTIMATE_CONSTANT from "../../constant/estimateConstant"
import type EstimateValues from "../../types/params"
import getConstantByValue from "../constant/getConstantByValue"
import getNumberOfLayers from "../getNumberOfLayers"

const resolveEmcShieldSideName = (value: string, { layer }: Pick<EstimateValues, "layer">) => {
  const numberOfLayers = getNumberOfLayers({ layer })
  const isOneLayer = numberOfLayers === 1

  switch (value) {
    case ESTIMATE_CONSTANT.電磁波シールド["パターン面と同じ面を貼る(L1面を貼る)(片面)"].value:
    case ESTIMATE_CONSTANT.電磁波シールド["パターン面と同じ面を貼る(L1面を貼る)(2層)"].value:
    case ESTIMATE_CONSTANT.電磁波シールド["パターン面と同じ面を貼る(L1面を貼る)(3層)"].value:
    case ESTIMATE_CONSTANT.電磁波シールド["パターン面と同じ面を貼る(L1面を貼る)(4層)"].value:
      return isOneLayer ? "パターン面と同じ面を貼る" : "L1面を貼る"
    case ESTIMATE_CONSTANT.電磁波シールド["パターン面と逆の面を貼る(Ln面を貼る)(片面)"].value:
    case ESTIMATE_CONSTANT.電磁波シールド["パターン面と逆の面を貼る(Ln面を貼る)(2層)"].value:
    case ESTIMATE_CONSTANT.電磁波シールド["パターン面と逆の面を貼る(Ln面を貼る)(3層)"].value:
    case ESTIMATE_CONSTANT.電磁波シールド["パターン面と逆の面を貼る(Ln面を貼る)(4層)"].value:
      return isOneLayer ? "パターン面と逆の面を貼る" : `L${numberOfLayers}面を貼る`
    default:
      return getConstantByValue("emcShield", value).name
  }
}

export default resolveEmcShieldSideName
